import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-circle',
    templateUrl: './circle.component.html',
    styleUrls: ['./circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CircleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
